import { TFunction } from 'i18next';
import { CountActiveFiltersArgs, FilterSelectOption } from './helpers.types';

export const getSellerTypeOptions = (
  t: TFunction,
  isShop?: boolean | null
): FilterSelectOption[] => [
  {
    label: t('common.all'),
    queryValue: undefined,
    isSelected: isShop === null,
  },
  {
    label: t('common.shop'),
    queryValue: 'true',
    isSelected: isShop === true,
  },
  {
    label: t('common.private'),
    queryValue: 'false',
    isSelected: isShop === false,
  },
];

type RangeBoundValue = number | string | null | undefined;

export type RangeBounds =
  | { valueFrom?: RangeBoundValue; valueTo?: RangeBoundValue }
  | [RangeBoundValue, RangeBoundValue]
  | null
  | undefined;

export function hasRangeBound(value: RangeBounds): boolean {
  if (value == null) return false;

  if (Array.isArray(value)) {
    return value[0] != null || value[1] != null;
  }

  return value.valueFrom != null || value.valueTo != null;
}

export function countActiveFilters<TBooleanValue, TRangeValue>({
  baseConditions,
  collectionValues,
  booleanValues,
  hasBooleanValue,
  rangeValues,
  hasRangeValue,
}: CountActiveFiltersArgs<TBooleanValue, TRangeValue>) {
  const base = baseConditions.filter(Boolean).length;
  const collections = collectionValues.filter(Boolean).length;
  const booleans = booleanValues.filter(
    hasBooleanValue ?? (v => v !== undefined)
  ).length;
  const ranges = rangeValues.filter(hasRangeValue).length;
  return base + collections + booleans + ranges;
}
